import StreamPreviewItemSkeleton from 'application/components/StreamPreviewItem/StreamPreviewItemSkeleton';
import React, { memo } from 'react';

const StreamPreviewCardSkeletons = memo(() =>
  Array.from({ length: 10 }, (_, index) => <StreamPreviewItemSkeleton key={index} />)
);

export default StreamPreviewCardSkeletons;
